'use strict';

import { graphql } from 'react-relay';

export const sbRespCollectionsRoot = graphql`
    query sbRespCollectionsRootQuery(
        $userId: String = ""
        $fetchUser: Boolean!
        $uriRef: String = ""
        $first: Int!
        $page: Int!
        $localeOrigin: String = ""
        $isTrade: Boolean!
        $showSeller: Boolean!
        $followSearchPages: [String]
        $followSearchTypes: [types] = [SEARCH]
        $contentModuleId: String = ""
        $eligibleAbTest: String = ""
        $regions: String = ""
        $userZipCode: String = "0"
        $userCountryCode: String = ""
        $fetchRegionalInfo: Boolean = false
        $fetchSb: Boolean!
        $disableForceFacet: Boolean = false
        $localRecentHistoryItemIds: [String] = []
        $fetchUserRecentHistoryItem: Boolean = false
    ) {
        viewer {
            ...getDomainLinksSb_viewer
            ...SbRespCollectionsLayout_viewer
            ...detectPageExistsAndRedirect_viewer
        }
    }
`;
